import React from 'react';
import { connect } from 'react-redux';
import { t } from '@lingui/macro';
import { onChangeMapFilters } from '../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../HOC/withDisplayedLayersCheck';
import { MapTimeline } from './MapTimeline';

/**
 * Привязка MapTimeline к «августовским» слоям с выбором года:
 *   - Агрегированные старты (август)            — mapFilters.aggStartsStatuses
 *   - Агрегированные финиши (август)            — mapFilters.aggFinishesStatuses
 *   - Агрегированая разница стартов и финишей (август) — mapFilters.aggDiffStartsFinishesStatuses
 *
 * Год выбирается прямо на таймлайне (categorical-домен), степпер в шапке не нужен.
 * Годы — те же, что у радиокнопок сайдбара (2021–2026, строки 'YYYY'). Перезапрос
 * тайлов делает существующая логика Map.jsx по смене mapFilters.
 *
 * Каждый компонент монтируется только когда его слой активен
 * (withDisplayedLayersCheck) — все три могут висеть в дереве одновременно.
 */

// Те же годы, что у сайдбара; на таймлайне — по возрастанию
const YEARS = [ 2021, 2022, 2023, 2024, 2025, 2026 ];
const DOMAIN = {
    type: 'categorical',
    values: YEARS.map(y => ({ value: y, label: String(y) })),
    format: y => String(y),
};

// Фабрика обвязки: один слой = один ключ mapFilters + ярлык слоя
function makeYearTimeline (stateKey, layerLabel) {
    const Component = ({ year, setYear }) => {
        const cursor = year ? Number(year) : YEARS[YEARS.length - 1];
        const onCursorChange = y => {
            const next = String(y);
            if (next !== String(year)) setYear(next);
        };

        return (
            <MapTimeline
                domain={DOMAIN}
                cursor={cursor}
                onCursorChange={onCursorChange}
            />
        );
    };
    const mapStateToProps = ({ mapFilters }) => ({ year: mapFilters[stateKey] });
    const mapDispatchToProps = dispatch => ({
        setYear: value => dispatch(onChangeMapFilters(stateKey, value)),
    });
    const Connected = connect(mapStateToProps, mapDispatchToProps)(Component);

    return withDisplayedLayersCheck(Connected, layerLabel);
}

export const AggStartsAugustYearTimeline = makeYearTimeline(
    'aggStartsStatuses',
    t`Агрегированные старты (август)`
);
export const AggFinishesAugustYearTimeline = makeYearTimeline(
    'aggFinishesStatuses',
    t`Агрегированные финиши (август)`
);
export const AggDiffStartsFinishesAugustYearTimeline = makeYearTimeline(
    'aggDiffStartsFinishesStatuses',
    t`Агрегированая разница стартов и финишей (август)`
);
